import type { TopArticleVM, ILogger } from '@jtnews/shared/seedwork/frontend/application';
import { TopArticlesBlockUseCaseError } from '@jtnews/shared/seedwork/frontend/application';

import { BaseArticlePresenter } from '../../base-article';
import { BlockPresenter } from '../block.presenter';

import type { TopArticleDTO } from './top-articles-block.dto';

export type TopArticlesBlockPresenterConfig = {
  deps: {
    logger: ILogger;
  };
};

export abstract class TopArticlesBlockPresenter<
  TOutput,
  TData,
  TParams = null,
> extends BlockPresenter<TOutput, TData, TParams> {
  private readonly _baseArticlePresenter = new BaseArticlePresenter();

  constructor(config: TopArticlesBlockPresenterConfig) {
    super(config);
  }

  protected presentTopArticle(data: TopArticleDTO): TopArticleVM {
    try {
      return {
        id: data.id,
        header: {
          text: data.header,
          link: data.urls?.url ?? '',
        },
        statistic: {
          comments: this._baseArticlePresenter.presentComments(data),
          views: this._baseArticlePresenter.presentViews(data),
        },
      };
    } catch (err) {
      throw TopArticlesBlockUseCaseError.of(
        'Не удалось выполнить presentTopArticle',
        err as Error,
      );
    }
  }
}
